import React, { useRef, useEffect } from 'react';
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'

export default function Page1({ sizeData, selectColor = 0, barcodeValue, data }) {
  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'

  const barcodeRef = useRef(null);
  useEffect(() => {
    console.log("countryyy",data)

    const svgElement = barcodeRef.current?.querySelector('svg');
    const textElement = svgElement?.querySelector('text');
    if (textElement) {
      textElement.style.fill = isBlack ? 'white' : '';
      textElement.style.transform = 'translateY(1px)';
    
    }
    if (svgElement) {
      svgElement.style.display = 'block';
      svgElement.style.verticalAlign = 'top';
    }
  }, [barcodeValue, isBlack]);  // barcodeValue veya isBlack değiştiğinde bu kod bloğunu çalıştır

  return (
    <div   className="flex flex-wrap gap-3">
      <LabelCard type="front" number={1}>
        <div className="pl-[4mm] pr-[7.5mm] pt-[2mm]">
        {isBlack && (
        <div style={{ backgroundColor: "white", height: 19, width: 163.9, position: "absolute", top: 10.6,left:18 }}></div>
      )}
          <div className="flex justify-center w-full" style={{ marginLeft: 7.2,marginTop:2 }}>
            {isBlack && <div className="h-[19px] w-3 mt-[1px]" />}
            <div className="inline-flex w-fit max-w-full flex-col">
              <div ref={barcodeRef} className="inline-flex flex-col leading-none gap-0 tracking-[.10rem] [&_svg]:block">
                <Barcode
                  value={barcodeValue?.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={1.12}
                  height={19}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={0}
                  textMargin={0}
                  background="transparent"
                  lineColor={isBlack ? '#000000' : '#000000'}
                  fontSize={9}
                  font="Arial"
                />
              </div>
              <div
                className="helveregular text-[6pt]"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gridTemplateRows: 'auto auto auto',
                  rowGap: 0,
                  width: '100%',
                  marginTop: '-7px',
                  lineHeight: 1,
                }}
              >
                <p
                  className="m-0 p-0 whitespace-nowrap"
                  style={{
                    gridColumn: 1,
                    gridRow: 1,
                    justifySelf: 'start',
                    color: isBlack ? '#FFFFFF' : '#000000',
                    marginTop: 3.7,
                  }}
                >
                  {`${data?.articleNo || 'N/A'}/${data?.washingLabel?.[selectColor]?.colorCode || 'N/A'}/${sizeData?.name || 'N/A'}`}
                </p>
                <p
                  className="m-0 p-0 whitespace-nowrap text-right"
                  style={{
                    gridColumn: 2,
                    gridRow: 1,
                    justifySelf: 'end',
                    color: isBlack ? '#FFFFFF' : '#000000',
                    marginTop: 3.7,
                    marginRight:3,
                  }}
                >
                  {sizeData?.cn || 'N/A'}
                </p>
                <p
                  className="m-0 p-0 whitespace-nowrap"
                  style={{ gridColumn: 1, gridRow: 2, justifySelf: 'start', marginTop: 3.9 }}
                >
                  RUC 80089348-4
                </p>
                <p
                  className="m-0 p-0 whitespace-nowrap text-right"
                  style={{ gridColumn: 2, gridRow: 2, justifySelf: 'end', marginTop: 3.9,marginRight:3 }}
                >
                  RN 77302
                </p>
                <div
                  className="m-0 p-0 [&_svg]:block [&_svg]:h-auto [&_svg]:w-full"
                  style={{
                    gridColumn: 1,
                    gridRow: 3,
                    justifySelf: 'start',
                    alignSelf: 'end',
                    marginTop: 10,
                    width: '19.7mm',
                    lineHeight: 0,
                    height: '2.7mm',
                  }}
                >
                  <GrupoLogo />
                </div>
                <p
                  className="m-0 p-0 whitespace-nowrap text-right"
                  style={{
                    gridColumn: 2,
                    gridRow: 3,
                    justifySelf: 'end',
                    alignSelf: 'end',
                    marginTop: 9.5,
                    paddingBottom: '0.5px',
                    marginRight:3
                  }}
                >
                  zara.com/contact
                </p>
              </div>
            </div>
            {isBlack && <div className="h-[19px] w-3 mt-[1px]" />}
          </div>
        </div>
      </LabelCard>
      <LabelCard type="back" number={2}>
        <div className="flex items-center h-full">
          <p className="scale-y-[158.7%] leading-[5.7pt] -tracking-[0.20px] px-[2.5mm]">
            INDITEX,S.A. AV. DIPUTACION ED.INDITEX ARTEIXO A CORUÑA (SPAIN) C.I.F. A-15075062
            TEXMODA S.A.S SIC 900.123.408 TAC ARGENTINA S.A. CUIT:30-69314836-3{' '}
            <span>
              V-
              {data?.country?.code || 'N/A'}
            </span>
            -21 AZKA LOGISTICS LLC, TEXTILES ANKA 22, C.A. - RIF.: J-50434538-5 REG N: 0008962TI-24
            MACROMODA S.A. RUC 1792159105001 INDITEX BRASIL LTDA. CNPJ:02952485000491  ITX CANADA LTD. CA 36685
          </p>
        </div>
      </LabelCard>
    </div>
  )
}
